import { DataRowType, DescriptionInputDataExcelUrl } from '@atlas-frontend/sdk';
import * as Icon from 'react-feather';
import { expand } from 'uri-template-lite';
import { Button } from 'antd';
import { RefObject, ReactNode, useCallback } from 'react';
import { Table } from '@tanstack/react-table';
import { OpenDirectoryButton } from '../../../common/OpenDirectoryButton';
import { path } from '../../../paths';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './InputDataActions.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('input-data-actions');
addTranslations(translations);

export interface InputDataActionsProps {
  id: number;
  valueDate: string;
  dataObjectVersionId?: number;
  tableRef: RefObject<Table<DataRowType> | null>;
  isDisabled?: boolean;
}

export function InputDataActions({
  id,
  valueDate,
  tableRef,
  dataObjectVersionId,
  isDisabled,
}: InputDataActionsProps): ReactNode {
  const { t } = useTranslation();

  const handleDownload = useCallback(() => {
    const filters = tableRef.current?.getState().columnFilters ?? [];
    let filterValue: string | undefined;
    if (filters?.length) {
      filterValue = encodeURIComponent(
        filters.map((filter) => `${filter.id}=${filter.value}`).join('&'),
      );
    }
    window.location.href = expand(DescriptionInputDataExcelUrl, {
      descriptionId: id,
      valueDate,
      filter: filterValue,
      dataObjectVersionId,
    });
  }, [id, valueDate, tableRef, dataObjectVersionId]);

  return (
    <>
      <Button
        id="download-input-data"
        style={{ display: 'grid', placeItems: 'center' }}
        icon={<Icon.Download size={18} />}
        onClick={handleDownload}
        disabled={isDisabled}
      />
      <OpenDirectoryButton
        options={[
          {
            id: 'inputDataDirectory',
            path: path.inputDataDirectory,
            label: t('button.inputDataDirectory'),
          },
          {
            id: 'inputDataErrorDirectory',
            path: path.inputDataErrorDirectory,
            label: t('button.inputDataErrorDirectory'),
          },
        ]}
      />
    </>
  );
}
